import React from "react";

const CheckCircle = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2 12C2 6.486 6.486 2 12 2C17.514 2 22 6.486 22 12C22 17.514 17.514 22 12 22C6.486 22 2 17.514 2 12ZM8.412 11.292L10.711 13.587L16.005 8.29303L17.419 9.70703L10.713 16.413L7 12.708L8.412 11.292Z"
        fill="#02F27B"
      />
    </svg>
  );
};

export default CheckCircle;
